import AclName from '../../../../acl/AclName.js';
import softDelete from '../../../abstract/actions/soft-delete';

export default {
  ...softDelete,
  acl: AclName.SettingsBtnInvoiceTemplateNumberDelete,
  render: ({ item: { _is_global } }) => !_is_global,
};
